import { Dispatch, SetStateAction } from 'react';
import { GridCellData } from '../../../../../../core/types/types';
import L from 'leaflet';

export const addLeafletGridLayer = (gridLayerRef: React.MutableRefObject<null>, squareGridCoordinates: any) => {
    const squareGrid = squareGridCoordinates.map((cells: any) =>
        L.rectangle(cells, {
            color: 'red',
            fillColor: 'red',
            fillOpacity: 0,
            weight: 0.8,
        }),
    );
    // Create a LayerGroup to hold the grid rectangles
    //@ts-ignore
    const gridLayerGroup = L.layerGroup(squareGrid);
    //@ts-ignore
    gridLayerRef.current = gridLayerGroup; // Save the LayerGroup reference in the ref
};

export const addCountryLeafletGridLayer = (
    gridLayerRef: React.MutableRefObject<null>,
    countryGridCoordinates: any,
    setPickedCells: Dispatch<SetStateAction<GridCellData[] | []>>,
) => {
    const squareGrid = countryGridCoordinates.map((cell: any) => {
        // console.log('cells: ', cells);
        const rectangle = L.rectangle(cell.coordinates, {
            color: 'red',
            fillColor: 'red',
            fillOpacity: 0,
            weight: 0.8,
        });
        rectangle.on('click', () => {
            if (rectangle.options.fillColor === 'red') {
                rectangle.setStyle({ fillColor: 'green', fillOpacity: 0.5 });
                //@ts-ignore
                setPickedCells((prevState) => {
                    return [...prevState, { cellId: cell.id, coordinates: cell.coordinates }];
                });
            } else {
                rectangle.setStyle({ fillColor: 'red', fillOpacity: 0 });
                //@ts-ignore
                setPickedCells((prevState) => {
                    return prevState.filter((test) => test.cellId !== cell.id);
                });
            }
        });

        return rectangle;
    });
    // Create a LayerGroup to hold the grid rectangles
    //@ts-ignore
    const gridLayerGroup = L.layerGroup(squareGrid);
    //@ts-ignore
    gridLayerRef.current = gridLayerGroup; // Save the LayerGroup reference in the ref
};
